jQuery(document).on('click', '.team .popup-button', function() {
  jQuery(this).closest('.team-popup').addClass('active');
  jQuery('body, html').css('overflow-y', 'hidden');
});

jQuery(document).on('click', '.popup-close', function() {
  jQuery(this).closest('.team-popup').removeClass('active');
  jQuery('body, html').css('overflow-y', 'auto');
});